export default "/assets/images/list-icon1.svg?a735f229d8e985613e741fc19f07d673";